
import {WORK_AMOUNT_UNIT_FLATFEE} from '../../../constants'
import {validateField, submitFields, clearFields, clearField, setFieldOptions, setFieldRequired} from './helpers/form'
import {
  FETCH_VACANCY_ACTIVATE_DATA_SUCCESS,
  VALIDATE_VACANCY_ACTIVATE_FIELD,
  VALIDATE_VACANCY_ACTIVATE_WORK_AMOUNT_UNIT_FIELD,
  TAKE_FIRST_STANDARD_RATE_ON_VACANCY_ACTIVATE,
  SUBMIT_VACANCY_ACTIVATE_FIELDS,
  CLEAR_VACANCY_ACTIVATE_FIELDS,
  CLEAR_VACANCY_ACTIVATE_FIELD
} from '../../../actions/pages/vacancy-page'

export function vacancyActivate(
  state = {
    valid: false,
    fields: [
      {
        name: 'Deadline',
        value: '',
        errors: [],
        rules: {
          title: 'Deadline'
        }
      },
      {
        name: 'WorkAmountQuantity',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Work amount quantity',
          required: true,
          numericGreaterThanZero: true
        },
        disabled: false
      },
      {
        name: 'WorkAmountUnit',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Work amount unit',
          required: true
        },
        options: []
      },
      {
        name: 'StandardRate',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Standard rate'
        },
        options: [],
        filteredOptions: []
      },
      {
        name: 'CustomRate',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Custom rate'
        },
        isCurrency: true,
        isNullable: true
      },
      {
        name: 'AdditionalNotes',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Notes',
          max: '1000'
        }
      },
      {
        name: 'AdditionalRate',
        value: '',
        errors: [],
        placeholder: 'Not applicable',
        rules: {
          title: 'Additional fee'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'AdditionalRateRecurrence',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Recurrence',
          required: true,
          numeric: true
        },
        disabled: false
      },
      {
        name: 'Description',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Description',
          min: 0,
          max: '30'
        }
      },
      {
        name: 'VisibilityType',
        value: '',
        errors: [],
        placeholder: '',
        rules: {
          required: true,
          title: 'Visibility'
        },
        options: [],
        filteredOptions: [],
        isNullable: false
      },
    ]
  },
  action
) {
  switch (action.type) {
    case FETCH_VACANCY_ACTIVATE_DATA_SUCCESS: {
      let fields = state.fields.map((field) => {
        let newValue;
        Object.entries(action.data).forEach(([key, value]) => {
          if (field.name === key){
            newValue = value;
            return;
          }
        })

        if (newValue !== undefined) {
          if (field.name == 'Description' && action.descriptionRequired) {
            return {
              ...field,
              value: newValue,
              errors: [],
              rules: {
                title: field.rules.title,
                min: 1,
                max: field.rules.max
              }
            }
          }
          return {
            ...field,
            value: newValue,
            errors: []
          }
        }

        return field;
      })

      let newState =  Object.assign({}, state, {
        valid: true,
        fields: Array.from(fields)
      })

      action.data.WorkAmountUnits.Items = action.data.WorkAmountUnits.Items.map(function (unit) {
        unit.label = unit.label.charAt(0).toUpperCase() + unit.label.slice(1);
        return unit;
      });

      newState = setFieldOptions(newState, 'WorkAmountUnit', action.data.WorkAmountUnits);

      // prepare list of filtered standard rates
      var filteredStandardRateOptions = action.data.StandardRates.Items.filter((option) => {
        return (action.data.WorkAmountUnits.SelectedValue === option.parameters.unit);
      });

      newState = setFieldOptions(newState, 'StandardRate', action.data.StandardRates, filteredStandardRateOptions);

      newState = setFieldOptions(newState, 'AdditionalRate', action.data.AdditionalRates);
      newState = setDisableAdditionalRateRecurrence(newState);

      newState = setDisableWorkAmountQuantity(newState);
      return setRequireCustomRate(newState);
    }

    case VALIDATE_VACANCY_ACTIVATE_FIELD: {
      let newState = validateField(state, action);

      newState = setRequireCustomRate(newState);

      newState = setDisableAdditionalRateRecurrence(newState);

      return newState;
    }

    case VALIDATE_VACANCY_ACTIVATE_WORK_AMOUNT_UNIT_FIELD: {
      let newState = validateField(state, action);

      var selectedWorkAmountUnit = action.field.value;

      let fields = newState.fields.map(item => {
        if (item.name === 'StandardRate') {
          var filteredStandardRateOptions = item.options.filter((option) => {
            return (selectedWorkAmountUnit === option.parameters.unit);
          });

          var selectedStandardRate = '';
          var firstDefaultRate = filteredStandardRateOptions.find(option => option.parameters.isDefault);
          if(firstDefaultRate){
            selectedStandardRate = firstDefaultRate.value;
          }

          return Object.assign({}, item, {
            filteredOptions: filteredStandardRateOptions,
            value: selectedStandardRate
          })
        } else {
          return item
        }
      })

      newState = Object.assign({}, newState, {
        fields: Array.from(fields)
      })

      newState = setDisableWorkAmountQuantity(newState);
      return setRequireCustomRate(newState);
    }

    case TAKE_FIRST_STANDARD_RATE_ON_VACANCY_ACTIVATE: {
      let selectedStandardRate = action.field.filteredOptions.length > 0 ? action.field.filteredOptions[0].value : '';

      let fields = state.fields.map(item => {
        if (item.name === action.field.name) {
          return Object.assign({}, item, {
            value: selectedStandardRate
          })
        } else {
          return item
        }
      })

      let newState = Object.assign({}, state, {
        fields: Array.from(fields)
      })

      newState = setRequireCustomRate(newState);

      return newState;
    }

    case SUBMIT_VACANCY_ACTIVATE_FIELDS:
      return submitFields(state, action);

    case CLEAR_VACANCY_ACTIVATE_FIELDS:
      return clearFields(state);

    case CLEAR_VACANCY_ACTIVATE_FIELD:
      return clearField(state, action.fieldName);

    default:
      return state
  }
}

function setDisableWorkAmountQuantity(state) {
  var workAmountUnitField = state.fields.find((el) => {
    return el.name === 'WorkAmountUnit';
  });

  let fields = state.fields.map(item => {
    if (item.name === 'WorkAmountQuantity') {
      if (workAmountUnitField.value === WORK_AMOUNT_UNIT_FLATFEE) {
        return Object.assign({}, item, {
          errors: [],
          value: 1,
          disabled: true
        })
      }
      else {
        return Object.assign({}, item, {
          disabled: false
        })
      }
    } else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function setDisableAdditionalRateRecurrence(state) {
  var additionalRateField = state.fields.find((el) => {
    return el.name === 'AdditionalRate';
  });

  let fields = state.fields.map(item => {
    if (item.name === 'AdditionalRateRecurrence') {
      if (additionalRateField.value === '') {
        return Object.assign({}, item, {
          errors: [],
          value: '0',
          disabled: true
        })
      }
      else {
        return Object.assign({}, item, {
          disabled: false
        })
      }
    } else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function setRequireCustomRate(state) {
  var workAmountUnitField = state.fields.find((el) => {
    return el.name === 'WorkAmountUnit';
  });

  var standardRateField = state.fields.find((el) => {
    return el.name === 'StandardRate';
  });

  var selectedRate = standardRateField.options.find((option) => {
    return option.value === standardRateField.value;
  });
  let isCustomRate = selectedRate && selectedRate.parameters.isCustomRate;

  let isRequiredCustomRate = workAmountUnitField.value === WORK_AMOUNT_UNIT_FLATFEE && isCustomRate;
  let isRequiredStandardRate = !isRequiredCustomRate;

  let fields = state.fields.map(item => {
    if (item.name === 'CustomRate') {
      return setFieldRequired(item, isRequiredCustomRate);
    }
    else if (item.name === 'StandardRate') {
      return setFieldRequired(item, isRequiredStandardRate);
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}
